import { Component, OnInit, Input, Output, EventEmitter, ViewChild} from "@angular/core";
import { ItineraryService } from "../../../shared/itinerary.service";
import { ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
import { ActivitiesComponent } from "../../../home/search-box/categories/activities/activities.component";
import { HotelsComponent } from "../../../home/search-box/categories/hotels/hotels.component";
import { PthemesComponent } from "../../../home/search-box/categories/pthemes/pthemes.component";
import { TransportsComponent } from "../../../home/search-box/categories/transports/transports.component";
import { RentcarsComponent } from "../../../home/search-box/categories/rentcars/rentcars.component";
import { InsuranceComponent } from "../../../home/search-box/categories/insurance/insurance.component";
import { DisneyComponent } from "../../../home/search-box/categories/disney/disney.component";
import { RestService } from "../../../shared/rest.service";
import { ModalDirective, BsModalService, BsModalRef, ModalOptions } from "ngx-bootstrap/modal";
import { FormGroup, Validators, FormBuilder, FormArray } from "@angular/forms";
import { UserService } from "../../../pages/com.usblick.common/auth/user.service";
import { Observable } from "rxjs";
import { FidelityService } from "../../../fidelity/fidelity.service";
import { ModalsComponent } from "../../../shared/modals/modals.component";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmationModalComponent } from "../../../shared/modals/confirmation-modal/confirmation-modal.component";
import { DynamicFontSizePipe } from "app/shared/dynamic-font-size.pipe";
import { CurrencyConverterPurePipe } from 'app/shared/currency-converter-pure.pipe';
import { OwlOptions } from 'ngx-owl-carousel-o';
import CssFilterConverter from "css-filter-converter";

@Component({
  selector: "usb-item-status",
  templateUrl: "./item-status.component.html",
  styleUrls: ["./item-status.component.scss"],
  providers: [DatePipe, DynamicFontSizePipe, CurrencyConverterPurePipe],
})
export class ItemStatusComponent implements OnInit {
  @ViewChild("modalRooms") modalRooms: ModalDirective;

  opt: any;
  @Input() status: string;
  @Input() reservation: any;
  @Input() selected: boolean;
  @Input() item: any;
  @Input() modifications: boolean;
  @Input() showTextChangeDetailsProducts: boolean;
  @Input() currencies: any[];
  @Input() currencyAgency: any;
  @Output() reserve = new EventEmitter<any>();
  @Output() update = new EventEmitter<string>();
  @Output() delete = new EventEmitter<string>();
  @Output() accept = new EventEmitter<string>();
  @Output() reSearch = new EventEmitter<any>();
  @Output() reloadItinerary = new EventEmitter<any>();
  @Input() changePriceFromReserve: boolean;
  @Input() clientsSettingAppBooking: any;

  @Output() itemToPartial = new EventEmitter<number>();
  @Output() partialSelection = new EventEmitter<{id: number, selected: boolean}>();
  @Output() hasPenalityEmmiter = new EventEmitter<any>();

  showTooltip = false;

  // Owl Carousel options para carousel de "Valor por noche"
  nightPriceOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 300,
    autoplay: false,
    smartSpeed: 300,
    fluidSpeed: true,
    navText: [
      '<img src="assets/img/app/little-icons/arrow-down-black.svg" style="width: 15px; height: 15px;">',
      '<img src="assets/img/app/little-icons/arrow-down-black.svg" style="width: 15px; height: 15px;">'
    ],
    responsive: {
      0: { items: 3 },
    },
    nav: true
  };

  // Datos temporales para el carousel - 4 elementos
  nightPrices: any[] = [
    { label: 'Noche 1', amount: 150.00, currency: 'USD' },
    { label: 'Noche 2', amount: 155.00, currency: 'USD' },
    { label: 'Noche 3', amount: 160.00, currency: 'USD' },
    { label: 'Noche 4', amount: 165.00, currency: 'USD' }
  ];

  @Input() partialReserve: boolean;

  _form: FormGroup;

  modalRef: BsModalRef;
  percentage: number = 0;
  blickoins: any;
  screen: string;
  fee: number = 0;
  totalPrice: number;
  netPriceBooking: number;
  optionNightsNetTotalFreeTax: number;
  taxNightsPriceTotal: number;
  taxPrice: number;
  netPriceAgent: number;
  itineraryDetail: any;
  itinerary: any;
  reservationId: number;
  addFee: any = "";
  activeGlobalFee: any;
  prices$: Observable<any[]>;
  globalFee$: Observable<any[]>;
  totalpartialNofee: number = 0;
  totalpartialYesfee: number = 0;
  showOthersItem: any;
  ModalRooms: any;
  newPrice: boolean = true;
  payload: any;
  result: any;
  arrayResults: any;
  index: number;
  form: FormGroup;
  origin: string;
  modal: boolean = false;
  public taxSum: number = 0;
  mapView: Boolean = false;
  addIcon = "favorite_border";
  netPriceProf = 0;
  public taxes: any[] = [];
  public taxesIncluded: any[] = [];
  public taxesExcluded: any[] = [];
  optionNightsNetTotal: number = 0;
  optionNightsNetTotalProf: number = 0;
  netPriceBookingFreeTax: number = 0;
  fontSizeAdjustments = { 9: -1 };

  bsModalRef?: BsModalRef;

  creditBlickoins = 0;
  view_hotel = 0;
  isview_hotel = false;
  ameninitiesResul = [];
  booleanAlert:boolean = true;
  currencyItinerary: string;
  styleSidebar: any;

  private filterCache = new Map<string, string>();

  constructor(
    private datePipe: DatePipe,
    private itineraryService: ItineraryService,
    private route: ActivatedRoute,
    private restService: RestService,
    private fb: FormBuilder,
    private _restService: RestService,
    public userService: UserService,
    private modalService: BsModalService,
    public fidelityService: FidelityService,
    private dialog: MatDialog,
    private currencyPipe: CurrencyConverterPurePipe,
  ) {
    this.opt = {
      acceptNewPrice: false,
      acceptOthersItem: false,
      acceptOthersSearch: false,
      search: false,
      delete: false,
      reserve: false,
    };
  }

  itemRateClass: string = '';

  // Usado en el template donde se lee item.item?.converted_amounts?.netPriceBooking directo (no
  // pasa por this.netPriceBooking, que ya suma esto en getPricesProduct()).
  get hotelTaxesExcluded(): number {
    return this.item?.item?.category_id === 1 ? (this.item?.item?.room?.pricing?.taxesExcluded || 0) : 0;
  }

  ngOnInit() {
 this.styleSidebar = JSON.parse(this.clientsSettingAppBooking.clients_setting_app_booking?.bookingFlow_sidebar);
    if(this.changePriceFromReserve) {
      this.showTextChangeDetailsProducts = true;
    }

    this.showOthersItem = false;
    this.selected = true;
    this.route.queryParams.subscribe((params) => {
      this.screen = params["screen"];
      if (this.screen == "reservation") {
        this.reservationId = params["reservationId"];
      }
      if (params["process"]) {
        this.addFee = params["process"];
      }
    });
    // console.log("modifications", this.modifications);
    // console.log('reservation -->', this.item.item.updateDate);


    this.item.product = {};
    this.getPricesProduct();
    // this.taxNightsPriceTotal = this.item.item.taxNightsPriceTotal;
    this.taxPrice = this.item.item.taxPrice;
    this.optionNightsNetTotalFreeTax = this.item.item.optionNightsNetTotalFreeTax;
    this.optionNightsNetTotal = this.item.item.optionNightsNetTotal;
    this.optionNightsNetTotalProf = this.item.item.optionNightsNetTotalProf;
    // this.netPriceBooking = this.item.item.netPriceBooking;
    // this.netPriceAgent = this.item.item.netPriceAgent;
    // this.netPriceBookingFreeTax = this.item.item.netPriceBookingFreeTax;
    this.creditBlickoins = this.item.item?.profility?.creditBlickoins;
    this.blickoins = this.item.item?.profility?.blickoins;
    this.percentage = this.item.item.percentageAgent;
    this.prices$ = this.userService.getPrices$();
    this.activeGlobalFee = this.userService.activeGlobalFee;
    this.currencyItinerary = this.item.item.currency;
    this.globalFee$ = this.userService.getGlobalFee$();
    this.globalFee$.subscribe((data: any) => {
      this.userService.itinerayDetailFee.products.forEach((element) => {
        if (element.item.id == this.item.id && element.source === 'Web') {
          this.percentage = data;
          // this.getFee();
        }
      });
      this.getFee();
    });
    /// this.getProduct();

    this.showPriceCancelled();

    if(this.item.item.status_id !== 5) {
      // Calcula la suma de los montos de impuestos incluidos y separa en dos arrays.
      // Items reservados antes de que existiera este campo pueden no traer room.pricing.taxes
      // — sin el "|| []" acá, el .reduce de abajo tira "Cannot read properties of undefined"
      // y rompe el render de toda la card.
      const taxes = this.item.item?.room?.pricing?.taxes || [];
      this.taxSum = taxes.reduce((total, tax) => {

        // Verifica si el valor de 'included' es un booleano
        if (typeof tax.included === 'boolean' && tax.included) {
          this.taxesIncluded.push(tax);
          this.taxes.push(tax);
          // Si el impuesto está incluido y 'included' es un booleano verdadero, sumarlo al total
          return total + tax.amount;
        } else {
          this.taxesExcluded.push(tax);
          this.taxes.push(tax);
          return total + Number(tax.amount);
        }
      }, 0); // Inicializa el total en 0
      // Formatea el resultado con dos decimales
      // this.taxSum = parseFloat(this.taxSum.toFixed(2));
      //
    }

    this.itemRateClass = this.getRateClass(this.item.item.category_id, this.item.item);

  }


  getPricesProduct(): void {

    if(this.item.item.status_id !== 5) {

          this.taxPrice = this.item.item.taxPrice;
          this.optionNightsNetTotalFreeTax = this.item.item.optionNightsNetTotalFreeTax;
          this.optionNightsNetTotal = this.item.item.optionNightsNetTotal;
          this.optionNightsNetTotalProf = this.item.item.optionNightsNetTotalProf;

          if((this.item.item.isPendigApprovePay || this.item.item.isPaidAgency || this.item.item.isPaidProvider) && this.item?.item?.amount_historic_payment) {
            this.netPriceBooking = this.item.item?.amount_historic_payment?.converted_amounts?.netPriceBooking;
            this.netPriceAgent = this.item.item?.amount_historic_payment?.converted_amounts?.netPriceAgent;
            this.netPriceBookingFreeTax = this.item.item?.amount_historic_payment?.converted_amounts?.netPriceBookingFreeTax;
            this.taxNightsPriceTotal = this.item.item?.amount_historic_payment?.converted_amounts?.taxPrice;
          } else {
            this.netPriceBooking = this.item.item.netPriceBooking;
            this.netPriceAgent = this.item.item.netPriceAgent;
            this.netPriceBookingFreeTax = this.item.item.netPriceBookingFreeTax;
            this.taxNightsPriceTotal = this.item.item.taxNightsPriceTotal;
          }

          // Impuestos no incluidos (a pagar en destino) — solo hotel, solo para mostrar. Vive en
          // item.room.pricing, no en item directo. No pisa el valor original si no hay nada que
          // sumar (item viejo sin este campo, u otra categoría).
          const itemTaxesExcluded = this.item.item.room?.pricing?.taxesExcluded;
          if (this.item.item.category_id === 1 && itemTaxesExcluded) {
            this.netPriceBooking = (this.netPriceBooking || 0) + itemTaxesExcluded;
            this.netPriceBookingFreeTax = (this.netPriceBookingFreeTax || 0);
          }

    } else {
       this.netPriceBooking = 0;
            this.netPriceAgent = 0;
            this.netPriceBookingFreeTax = 0;
            this.taxNightsPriceTotal = 0;
    }
  }


  calSync(date: any){
    /*let date_ =  new Date(date);
      if (date_) {
        console.log("llegando fecha: ", date_);
        return date_.setMinutes(date_.getMinutes() - 10);
      }*/
  }

  getDayName(dateStr: string): string {
    const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const date = new Date(dateStr + 'T00:00:00');
    return days[date.getDay()];
  }

  _showOthersItem() {
    if (this.showOthersItem) {
      this.showOthersItem = false;
    } else {
      this.showOthersItem = true;
    }
  }

  getProduct() {
    if (this.item.item.payloadUpdate) {
      this.restService.doPost("app", "search/products", this.item.item.payloadUpdate).subscribe(
        (response: any) => {
          if (response && response.status && response.results) {
            if (response.results[0] !== undefined) {
              this.item.product = response.results[0];
            } else {
              this.item.product = response.results;
            }
          }
        },
        (error) => {
          console.log(error.message);
        }
      );
    }
  }

  getExpirationDate(date: any) {
    // return this.datePipe.transform(moment(this.reservation.resultReserve.additionalInfo.payBefore), 'MMM dd, yyyy')
    //  return this.datePipe.transform(date, 'dd/mm/yyyy h:m');
    const dateOut = new Date(date);
    return dateOut;
  }
  updateItem() {
    this.update.emit("non-updated");
  }


  deleteItem() {
    this.opt = {
      accept: false,
      search: false,
      delete: true,
      reserve: false,
    };
    this.itineraryService.remove(this.item.item !== undefined ? this.item.item : this.item);
    setTimeout(() => {
      this.delete.emit(this.item.item.id);
      window.location.reload();
    }, 500);
  }



  deleteAndSearch() {
    this.opt = {
      accept: false,
      search: true,
      delete: false,
      reserve: false,
    };
    this.itineraryService.remove(this.item.item !== undefined ? this.item.item : this.item);

    setTimeout(() => {
      switch (this.item.item.categoryName) {
        case "HOTELS":
          let hotel: HotelsComponent;
          hotel._onSubmit(this.item.item.form);
          break;
        case "PTHEMES":
          let ptheme: PthemesComponent;
          ptheme._onSubmit(this.item.item.form);
          break;
        case "TRANSPORTS":
          let transport: TransportsComponent;
          transport._onSubmit(this.item.item.form);
          break;
        case "RENT-A-CAR":
          let car: RentcarsComponent;
          car._onSubmit(this.item.item.form);
          break;
        case "INSURANCE":
          let insurance: InsuranceComponent;
          insurance._onSubmit(this.item.item.form);
          break;
        case "DISNEY":
          let disney: DisneyComponent;
          disney._onSubmit(this.item.item.form);
          break;
        case "TOURS":
          let tour: ActivitiesComponent;
          tour._onSubmit(this.item.item.form);
          break;

        default:
          break;
      }
    }, 1500);
  }

  acceptNewPrice() {

    const item = this.item.item;
    let message: string = '';
    if(item?.syncProduct?.codeLabelStatus === 'PRODUCT_CANCELLATION_POLICY_CHANGED') {
      message = '¿Deseas aceptar las nuevas políticas de cancelación? verificar en producto'
    } else {
      const convertedPrice = this.currencyPipe.transform(item.syncProduct?.newPrice?.profility?.netPriceBooking, this.item?.item?.currency, this.currencyAgency.code, this.currencies);

      message = `¿Deseas aceptar nuevo precio? ${this.currencyAgency.code} ${convertedPrice.toFixed(2)}`;
    }

    const initialState: ModalOptions = {
      initialState: {
        message: message,
      }
    };

    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
    const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
      if(result) {

        this.item.item.refPrice =  item.syncProduct?.newPrice?.profility?.netPriceProvider;
        this.item.item.netPriceProvider = item.syncProduct?.newPrice?.profility?.netPriceProvider;
        this.item.item.netPriceBooking = item.syncProduct?.newPrice?.profility?.netPriceBooking;
        this.item.item.netPriceAgent =  item.syncProduct?.newPrice?.profility?.netPriceAgent;
        this.item.item.blickoins = item.syncProduct?.newPrice?.profility?.blickoins;

        this.accept.emit();
        setTimeout(() => {
          this.userService.postNewPrice(this.item);
        }, 500);
      } else {
        this.opt.acceptNewPrice = false;
      }

    });
    this.booleanAlert = false;
  }

  getCancellationPoliciesBefore(item: any, time: string): any {

    let cancellation= {before: [], after: []};

    if(time === 'before') {
      cancellation.before = item.item?.syncProduct?.olderCancellationPolicy || [];
    } else {
      cancellation.after = item.item?.syncProduct?.newCancellationPolicy || [];
    }

    return cancellation
  }

  openModal_(tab: any) {
    this.modal = true;
    this.updteView();

    if (localStorage.getItem('form')) {
      localStorage.removeItem('form');
    }

    const dialogRef = this.dialog.open(ModalsComponent, {
      height: '680px',
      width: '920px',
      data: {
        modalRoomRef: this.modalRef,
        product: this.item.result.results[0],
        productQty: 1, /// this.payload.qtyProduct,
        form:  this.item.item.form,
        origin: 'HOTELS',
        arrayResults: this.item.result.results[0].additionalInfo.room,
        tabActive: tab,
        view_info: false
      },
    });

    dialogRef.afterClosed().subscribe((result) => {

      this.reloadItinerary.emit();

      if (result) {
      ///  this.reloadItinerary.emit();
      ///  this.itineraryService.remove(this.item.item !== undefined ? this.item.item : this.item.item);

    /*    var dialogRef = this.dialog.open(MaterialModalAlertComponent, {
          height: "auto",
          width: "350px",
          data: "producto Agreado satisfactoriamente"
        });
        dialogRef.afterClosed().subscribe(result_ => {
          if (result_) {
            console.log("emitir actualizar");
            this.reloadItinerary.emit();
          }
        }); */
      }
    });
  }


  openModal() {
    var dialogRef = this.dialog.open(ModalsComponent, {
      height: '680px',
      width: '800px',
      data: {
        modalRoomRef: this.modalRef,
        product: this.item.product,
        productQty: "1",
        //form: this.activeItineraryForm,
        origin: 'HOTELS',
        itineraryItem: this.item.item,
        view_info: true,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
    });

  }

  updteView() {
    let data = "";
    if (!this.isview_hotel) {
      this._restService.doPut("app", "products/updateView/" + this.item.result.results[0].id, data).subscribe(
        (response: any) => {
          if (response.success) {
            this.view_hotel = response.res.qtyview;
            this.isview_hotel = true;
          }
        },
        (error) => {
          console.log("Save-Error: " + error);
        }
      );
    }
  }

  acceptOthersOtherItem() {
    const initialState: ModalOptions = {
      initialState: {
        title: 'Eliminar',
        message: '¿Desea eliminar este producto<br />y ver otras opciones?',
        icon: 'assets/icons/itinerary-detail/04-01.svg'
      }
    };
    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
    const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
      if(result) {
        if (result) {
          this.itineraryService.remove(this.item.item !== undefined ? this.item.item : this.item.item);
         setTimeout(() => {
            this.openModal_('rooms');
          }, 1000);
        } else {
          this.openModal_('rooms');
        }
      } else {

      }
      confirmSubscription.unsubscribe();
    });
  }

  acceptOthersSearch() {
    const initialState: ModalOptions = {
      initialState: {
        message: '¿Desea hacer una nueva búsqueda?'
      }
    };

    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
    const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
      if (result) {
        this.reSearch.emit(this.item.item);
        // this.itineraryService.remove(this.item.item !== undefined ? this.item.item : this.item.item);
     } else {
       this.reSearch.emit(this.item.item);
     }
      confirmSubscription.unsubscribe();
    });
  }

  removeItem() {
    this.itineraryService.remove(this.item.item !== undefined ? this.item.item : this.item);
    setTimeout(() => {
      this.delete.emit(this.item.item.id);
    }, 500);
  }
  reserveItem() {
    this.opt = {
      accept: false,
      search: false,
      delete: false,
      reserve: true,
    };
    setTimeout(() => {
      this.reserve.emit();
      this.itineraryService.updateItineraryPartial(this.item.item);
    }, 50);
  }

  getClxDate(date: any) {
    return this.datePipe.transform(date, "MMM dd, yyyy");
  }

  updateItemsFee(e: any) {
    const percentage = e.target.value;
    const netPriceAgent = this.item.item.netPriceBooking / (1 - percentage / 100);
    this.fee = netPriceAgent - this.item.item.netPriceBooking;
    this.userService.itinerayDetailFee.products.forEach((element) => {
      if (element.id == this.item.item.id && element.status_id == 1 && element.source === 'Web') {
        element.percentageAgent = percentage;
        element.fee = netPriceAgent - element.netPriceBooking;
        element.netPriceAgent = netPriceAgent;
      }
    });
    this.netPriceAgent = netPriceAgent;
    setTimeout(() => {
      this.userService.updateProductsPrices(this.item.item.itinerary_id);
    }, 50);
  }

  getFee() {
    if (this.percentage < 0) {
      this.percentage = 0;
    }

    if (this.percentage != 0) {
      this.netPriceAgent = this.item.item.netPriceBooking / (1 - this.percentage / 100);
      this.fee = this.netPriceAgent - this.item.item.netPriceBooking;
    } else {
      this.fee = 0;
      this.netPriceAgent = this.item.item.netPriceBooking;
    }

    this.userService.itinerayDetailFee.products.forEach((element) => {
      if (element.id == this.item.item.id && element.status_id == 1 && element.source === 'Web') {
        element.percentageAgent = this.percentage;
        element.netPriceAgent = this.netPriceAgent;
      }
    });
    setTimeout(() => {
      this.userService.updateProductsPrices(this.item.item.itinerary_id);
    }, 50);
  }

  initPayload() {
    this._form = this.fb.group({
      destination: ["", Validators.compose([Validators.required])],
      arrivalDate: [null, Validators.compose([Validators.required])],
      departureDate: [null, Validators.compose([Validators.required])],
      room: this.fb.array([]),
      qtyProduct: [1, [Validators.required, Validators.min(1), Validators.max(7)]],
    });

    const room = this._form.get("room") as FormArray;
    room.push(
      this.fb.group({
        qtyAdults: [0, [Validators.required, Validators.min(1)]],
        qtyChilds: [0, Validators.required],
        childsage: this.fb.array([]),
      })
    );
  }

  _setArrivalAndDepartureDate(response: any, form) {
    response.results.forEach((obj) => {
      obj.dateIni = moment(form.value["arrivalDate"].toString().split(",")[0]).format("YYYY-MM-DD");
      obj.dateEnd = moment(form.value["departureDate"].toString().split(",")[0]).format("YYYY-MM-DD");
    });
  }

  toPartialReserve(event, item: any) {
    const itemId = item.item?.id || item.id;


    if (event.target.checked) {
      this.itineraryService.updateItineraryPartial(item.item);
      this.partialSelection.emit({id: itemId, selected: true});
      this.itemToPartial.emit(1);
    } else {
      this.itineraryService.updateItineraryPartial(item.item, true);
      this.partialSelection.emit({id: itemId, selected: true});
      this.itemToPartial.emit(-1);
    }
    setTimeout(() => {
      this.userService.reCalcularPrices(this.item.item.itinerary_id);
    }, 500);
  }



  subtractDays(date) {
    return moment(moment(date)).subtract(2, "days").format("YYYY-MM-DD");
  }


  fontPrice(price: number) {
    if (price > 1000) {
      const size = 20 - 1.5;
      return size + "px";
    }
    if (price > 10000) {
      const size = 20 - 2.5;
      return size + "px";
    }
    if (price > 100000) {
      const size = 20 - 3.5;
      return size + "px";
    }
  }

  showPriceCancelled():void{
    let valuePrice = this.item?.item?.status_id;
    if(valuePrice === 5){
      this.netPriceBookingFreeTax = 0;
      this.netPriceAgent = 0;
      this.netPriceBooking = 0;
      this.blickoins = 0;
      this.creditBlickoins = 0;
    }
  }

  hasPenality(cancellation: any): boolean {
    return cancellation.some(c => c.apply === true);
  }

  getCancellationPolicies(category, item) {

    const currentDate = new Date();
    const defaultPolicy = {
        currency: this.currencyAgency?.code,
        from: currentDate,
        amount: 0,
        apply: false
    };

    // Determinar el array de políticas según la categoría
    let policies: any[] = [];

    policies = this.itemCancellationPolicies(category, item);

    // Si no hay políticas, retornar el default
    if (policies.length === 0) {
        return [defaultPolicy];
    }

    // Ordenar políticas por fecha 'from'
    const sortedPolicies = [...policies].sort((a, b) =>
        new Date(a.from).getTime() - new Date(b.from).getTime()
    );

    // Encontrar la política aplicable
    let applicableIndex = -1;
    for (let i = 0; i < sortedPolicies.length; i++) {
        if (new Date(sortedPolicies[i].from) <= currentDate) {
            applicableIndex = i;
        } else {
            break;
        }
    }

    // Preparar el resultado con el campo apply
    const result = sortedPolicies.map((policy, index) => {
      const baseRate = this.currencies.find(c => c.code === policy.currency)?.rate || 1;
      const targetRate = this.currencyAgency?.rate || 1;

        const isApplicable = index === applicableIndex;
        const amount = policy.amount;

        return {
            ...policy,
            currency: this.currencyAgency?.code,
            amount: amount,
            apply: isApplicable
        };
    });

    // Si no hay ninguna aplicable y hay políticas, marcamos todas como no aplicables
    if (applicableIndex === -1 && result.length > 0) {
      const targetRate2 = this.currencyAgency?.rate || 1;
      return result.map(policy => ({
            ...policy,
            currency: this.currencyAgency?.code,
            amount: policy.amount,
            apply: false
        }));
    }

    return result;
}

getAlertFilter(item: any): string {
  if (!item) return '';

  // Crear una key única basada en el item y su estado
  const cacheKey = this.getFilterCacheKey(item);

  // Si ya tenemos el filtro en caché, devolverlo
  if (this.filterCache.has(cacheKey)) {
    return this.filterCache.get(cacheKey) || '';
  }

  const color = this.getAlertColor(item);
  const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });
  const tempFilterStr = Object.keys(tempFilterObj)
    .map(key => `${key}(${tempFilterObj[key]})`)
    .join(" ");

  const colorRegex = /color\((.*)\)/;
  const colorMatch = tempFilterStr.match(colorRegex);
  const filter = colorMatch ? colorMatch[1] : "";

  // Guardar en caché
  this.filterCache.set(cacheKey, filter);

  return filter;
}

private getFilterCacheKey(item: any): string {
  // Crear key basada en propiedades relevantes
  return `${item?.item?.syncProduct?.priceNonAvailable}_${item?.item?.syncProduct?.nonAvailable}_${item?.item?.status_id}`;
}

getAlertColor(item: any): string {
    if (item?.item?.syncProduct?.priceNonAvailable) {
        return '#00d397'; // verde
    } else if (item?.item?.syncProduct?.nonAvailable && item?.item?.status_id === 1) {
        return '#d60159'; // rosa/magenta
    } else if(this.showTextChangeDetailsProducts &&
              !item.item?.syncProduct?.nonAvailable &&
              !item.item?.syncProduct?.priceNonAvailable &&
              item.item?.syncProduct?.codeLabelStatus !== 'PRODUCT_CANCELLATION_POLICY_CHANGED' &&
              item.item.status_id === 1) {
                return '#d60159';
              }
    return '#000000'; // color por defecto
}


getPenality(item: any): boolean {

  if(item.item.status_id !== 1 && item.item.status_id !== 5) {
    return false;
  }

  let hasCancellation: any[] = [];
  let hasPenality = false;

  hasCancellation = this.itemCancellationPolicies(item.item.category_id, item.item);

  if(hasCancellation.length === 0) {
    return false;
  }

  hasPenality = this.getCancellationPolicies(item.item.category_id, item.item).some(c => c.apply === true);

  // if(hasPenality && item.item.status_id === 1) {
  //   this.hasPenalityEmmiter.emit(true);
  // } else {
  //    this.hasPenalityEmmiter.emit(false);
  // }

  return hasPenality;
}

itemCancellationPolicies(category, item): any[] {
  let hasCancellation: any[] = [];

  switch(category) {
    case 1:
      hasCancellation = item?.room?.cancellationPolicy || [];
      break;
    case 2:
      break;
    case 6:
      hasCancellation = item.cancellationPolicies?.cancellationPolicies || [];
      break;
    case 8:
      hasCancellation = item.cancellationPolicies || [];
      break;
    case 10:
      hasCancellation = item.cancellationPolicies || [];
      break;
    default:
  }

  return hasCancellation;
}

  getRateClass(category: any, item: any): string {

    let rateClass: string = '';
    switch(category) {

      case 1:
        rateClass = item?.room?.rateClass;
        break;
      case 2:
        rateClass = item?.rateClass;
        break;
      case 6:
        rateClass = item?.rateClassId;
        break;
      case 8:
        rateClass = item?.pricing?.rateClass;
        break;
      case 9:
        rateClass = 'NR';
        break;
      case 10:
        rateClass = item.rateClass;

    }

    return rateClass;
  }


}
